import {utilityService} from "_services";

export default function useShopifySetup(){

  const performAction = () => {
    utilityService.redirectToAuthUrl('https://apps.shopify.com/chatdesk-email-social-media-customer-service');
  };

	return {
		initiateShopifySetup: performAction
	};
}